import React from "react";
import "./Intro.css";
import video from "../../video/mockup.mp4";

const Intro = () => {
  return (
    <div className="intro">
      {/* Left Side */}
      <div className="i-left">
        <div className="i-name">
          <span>A social media</span>
          <span>for Hobbyists</span>
          <span>A place where your niche hobby becomes your side hustle.</span>
          <span>Create, teach, sell and turn your passion into profit.</span>
        </div>
        <a
          href="https://hobbestie.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="button i-button">Sign Up</button>
        </a>
      </div>

      {/* Right Side */}
      <div className="i-right">
        <div className="video-mockup">
          <video autoPlay loop muted>
            <source src={video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* blur divs */}
        <div className="blur1"></div>
        <div className="blur2"></div>
      </div>
    </div>
  );
};

export default Intro;
